import React from 'react'
import Logo from '../assets/logo.svg'
import { Link } from 'react-router-dom'
import BG from '../assets/svg/myaccount-bg.svg'
import CopyrightFooter from '../components/CopyrightFooter'
const AccountLayout = (props) => {
    return (
       <>
        <div style={{backgroundImage: `url(${BG})`}} className="bg-cover bg-top bg-no-repeat flex items-center flex-col min-h-screen py-5 justify-center">
            {props.showWelcome && <h2 className="text-xle font-bold mb-1">Welcome to</h2>}
            <img src={Logo} alt="Viewpro" />
            <div className="bg-white w-88 p-4 mb-9 mt-13  rounded-md">
            {props.children}
            </div>
          
            
        </div>
        <CopyrightFooter fixedBottom={true} />
       </>
    )
}


export default AccountLayout

